import StorageHelper from './StorageHelper';

export default new StorageHelper(window.sessionStorage);



// WEBPACK FOOTER //
// ./src/utils/SessionStorageHelper.js